import { QuestionModalConfirmArg } from "@app/screens/ExternalQuestionnaires/externalQuestionnaire/components/OverviewTab/types";
import { SupportedLocales } from "@app/shared/utils/locales";
import {
    MultiLocaleString,
    SupplierTemplateQuestionCreateInput,
} from "@generated/client/graphql";

export const getFirstAvailableTranslation = (
    multiLocaleString: MultiLocaleString | null | undefined,
) => {
    const availableLocales = Object.values(SupportedLocales);
    const foundLocale = availableLocales.find(
        (locale) => multiLocaleString?.[locale],
    );
    return foundLocale ? multiLocaleString?.[foundLocale] : undefined;
};

export function makeTemplateQuestionCreateInput(
    question: QuestionModalConfirmArg,
): SupplierTemplateQuestionCreateInput {
    if (!question?.nameMultiLocale || !question?.type)
        throw new Error("Invalid template question input");

    return {
        nameMultiLocale: question.nameMultiLocale,
        type: question.type,
        tagIds: question.tagIds,
        descriptionMultiLocale: question.descriptionMultiLocale,
        metadata: question.metadata,
        order: question.order,
        isRequired: question.isRequired,
    };
}
